import ExpandOnView from "./ExpandOnView";

const projects = [
  {
    title: "Exhibition & Museum Design",
    description:
      "We conceptualize and design exhibitions and museums that go far beyond visual display — they are cultural landmarks that engage, educate, and inspire. Our expertise lies in combining architecture, design, and interactive storytelling to create environments where knowledge becomes an experience. From large-scale national museums to temporary showcases, we ensure each space leaves a lasting impression. ",
  },
  {
    title: "Storytelling & Scenography",
    description:
      "Every story deserves a stage that brings it to life. Through scenography and spatial storytelling, we shape environments that transform narratives into living experiences. Using light, sound, form, and movement, we create immersive worlds where visitors don’t just observe but feel part of the story.",
  },
  {
    title: "Content & Research",
    description:
      "Authenticity is at the heart of every meaningful experience. Our content and research team dives deep into history, culture, and context to uncover the details that matter. This rigorous foundation allows us to curate stories with integrity, ensuring each project is not only visually compelling but intellectually rich and accurate.",
  },
  {
    title: "Creative Direction & Experience",
    description:
      "Design is more than aesthetics — it’s about how people feel, move, and connect within a space. Our creative direction ensures every element, from visuals to user flows, works in harmony to deliver a seamless, human-centered experience. We balance artistry with usability, crafting moments that are intuitive, personal, and unforgettable.",
  },
];

export const Service = () => {
  return (
    <div className="flex flex-col items-center justify-start min-h-screen text-white h-full mt-12 lg:mt-40 w-screen overflow-hidden">
      <section className="relative w-full min-h-screen text-white font-sans flex flex-col justify-center items-center pl-20 lg:pl-32 ">
        {/* Vertical line and rotated labels - fixed positioning to avoid layout shift */}
        <div className="absolute left-0 top-0 h-full w-10 md:w-12 lg:w-24 z-20 pointer-events-none">
          {/* Vertical line */}
          <div
            className="absolute left-full top-0 h-full w-px bg-[#b6a6c9] opacity-30"
            style={{ transform: "translateX(-50%)" }}
          ></div>
          {/* Rotated labels */}
          <span
            className="px-2 py-1 absolute top-1/2 left-full -translate-x-1/2 -translate-y-1/2 rotate-[-90deg] tracking-[0.3em] text-xs text-[#b6a6c9] font-light uppercase whitespace-nowrap select-none pointer-events-none backdrop-blur-sm"
            style={{ letterSpacing: "0.3em" }}
          >
            Our Expertises
          </span>
        </div>

        {/* Main content */}
        <div className="flex flex-col">
          {projects.map((project) => (
            <ExpandOnView
              key={project.title}
              heading={project.title}
              description={project.description}
            />
          ))}
        </div>
      </section>
    </div>
  );
};
